/* =========================================================
   SMA Product Card
   - Custom pill selection (radio-style)
   - Updates the quick-add button price on pill change
   - Lets <product-form> handle the actual add-to-cart submit
     (the hidden variant id is wired to the lowest-priced variant)
   ========================================================= */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var amount = Math.round((cents || 0) / 100);
    if (format) {
      return format
        .replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/g, function () {
          return amount.toLocaleString('en-IN');
        })
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, function () {
          return amount.toLocaleString('en-IN').replace(/,/g, ' ');
        });
    }
    return '₹' + amount;
  }

  function initCard(card) {
    if (card.dataset.smaInit === 'true') return;
    card.dataset.smaInit = 'true';

    var dataScript = card.querySelector('script[type="application/json"][data-sma-variants]');
    var data = { optionNames: [], variants: [] };
    if (dataScript) {
      try { data = JSON.parse(dataScript.textContent) || data; } catch (e) {}
    }
    var moneyFormat = card.getAttribute('data-sma-money-format') || '₹{{amount_no_decimals}}';
    var defaultPrice = parseInt(card.getAttribute('data-sma-default-price') || '0', 10);
    var defaultVariantId = card.getAttribute('data-sma-default-id') || '';

    var priceEl = card.querySelector('.sma-card__quick-add-price');
    var variantIdInput = card.querySelector('.sma-card__form [name="id"]')
      || card.querySelector('input[name="id"].product-variant-id');
    var submitBtn = card.querySelector('.sma-card__quick-add');

    var pillRows = card.querySelectorAll('.sma-card__pills');
    pillRows.forEach(function (row) {
      var pills = row.querySelectorAll('.sma-card__pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          pills.forEach(function (p) {
            p.setAttribute('aria-checked', 'false');
            var input = p.querySelector('input[type="radio"]');
            if (input) input.checked = false;
          });
          pill.setAttribute('aria-checked', 'true');
          var picked = pill.querySelector('input[type="radio"]');
          if (picked) picked.checked = true;
          updateSelection();
        });
        pill.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            pill.click();
          }
        });
      });
    });

    function getSelectedByPosition() {
      var selected = [];
      var inputs = card.querySelectorAll('.sma-card__pill input[type="radio"]:checked');
      inputs.forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-position') || '-1', 10);
        if (pos >= 0) selected[pos] = input.value;
      });
      return selected;
    }

    function findVariant() {
      var sel = getSelectedByPosition();
      if (!data.variants || !data.variants.length) return null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var opts = v.options || [];
        var match = true;
        for (var p = 0; p < sel.length; p++) {
          if (sel[p] == null) continue;
          if (opts[p] !== sel[p]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateSelection() {
      var v = findVariant();
      var cents = v ? v.price : defaultPrice;
      var id = v ? v.id : defaultVariantId;
      var available = v ? (v.available !== false) : true;

      if (priceEl) {
        priceEl.textContent = formatMoney(cents, moneyFormat);
      }

      if (variantIdInput && id) {
        variantIdInput.value = id;
        if (available) {
          variantIdInput.removeAttribute('disabled');
        } else {
          variantIdInput.setAttribute('disabled', 'disabled');
        }
      }

      if (submitBtn) {
        if (available) {
          submitBtn.removeAttribute('disabled');
          submitBtn.removeAttribute('aria-disabled');
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.setAttribute('aria-disabled', 'true');
        }
      }
    }

    updateSelection();
  }

  function initAll(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.classList && root.classList.contains('sma-card')) {
      initCard(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.sma-card').forEach(initCard);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) initAll(e.target);
  });

  // Watch for dynamically inserted cards (related-products / AJAX filters /
  // infinite scroll / quick-add modals) so they get pill handlers too.
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node && node.nodeType === 1) initAll(node);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();